import React from "react";
import { useMediaQuery } from "@mui/material";
import { Notification } from "react-admin";

export const MyNotification = () => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  return (
    <Notification
      anchorOrigin={isMobile ? { vertical: "top", horizontal: "center" } : { vertical: "bottom", horizontal: "center" }}
    />
  );
};
